import type { CharacterStay } from "@/data/rail-branches";
import { staysOf } from "../StayAt/stay";

/** Rails sit on top of each other this close to a split or a join, so nothing shows there. */
const HIDDEN_NEAR_EDGE_MS = 1_000;
const FADE_MS = 1_500;

const clamp01 = (value: number): number => Math.min(1, Math.max(0, value));

/**
 * A past self shares a seat with the present self while their rails meet, which would show
 * two of one person. So it fades in after the rails part, and out before they join.
 */
export function flashbackSelfFade(
  stays: readonly CharacterStay[],
  characterId: string,
  stay: CharacterStay,
  playheadMs: number,
  /** Rode out of, or slides back into, someone on stage at that edge, so nothing doubles. */
  edges: { joined?: boolean; rejoins?: boolean } = {},
): number {
  if (!characterId.includes("@")) {
    return 1;
  }
  const own = staysOf(stays, characterId);
  const continuesFrom = own.some((other) => other.endMs === stay.startMs) || edges.joined === true;
  const continuesTo = own.some((other) => other.startMs === stay.endMs)
    || edges.rejoins === true;
  const fadeIn = continuesFrom
    ? 1
    : clamp01((playheadMs - stay.startMs - HIDDEN_NEAR_EDGE_MS) / FADE_MS);
  const fadeOut = continuesTo
    ? 1
    : clamp01((stay.endMs - playheadMs - HIDDEN_NEAR_EDGE_MS) / FADE_MS);
  return Math.min(fadeIn, fadeOut);
}
